//convert YYYY-MM-DD into MM/DD
export const convertDateFormat = (date = '') => {
	const dateArray = date.split('-');
	return dateArray[1] + '/' + dateArray[2] + '/' + dateArray[0];
};

export const convertDateFormatToMonthDate = (date = '') => {
	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	];
	const dateArray = date.split('-');
	return months[Number(dateArray[1])] + ' ' + dateArray[2];
};
n